import Vue from 'vue'
import Vuex from 'vuex'
import typeOf from '@/utils/typeof'
import Staff from '@/plugins/staff/staffServer'
import staffExit from '@/components/Dialogs/staffExit'
import StaffYawp from '@/components/Dialogs/staffYawp'
import switcher from '@/plugins/staff/role.switcher'
import { confirm } from '@/components/Dialogs'
import cache from '@/plugins/storage'
import {
  initApp,
  askQuestion,
  getRobotConfig,
  deepseekChat
} from '@/api/chat'
import { buildData } from '@/components/Bubbles/interface'
// const Fingerprint = require('@/plugins/fingerprint')
const loadings = []

Vue.use(Vuex)

// 从 localStorage 中获取缓存的 conversation_id
function getCachedConversationId () {
  return localStorage.getItem('deepseek_conversation_id')
}

// 将 conversation_id 缓存到 localStorage
function cacheConversationId (conversationId) {
  localStorage.setItem('deepseek_conversation_id', conversationId)
}

// 处理DeepSeek流式响应并转换为JSON
async function handleDeepSeekStreamResponse (apiMethod, json, store) {
  return new Promise((resolve, reject) => {
    // 从缓存中获取 conversation_id 并添加到 json 中
    const cachedConversationId = getCachedConversationId()
    if (cachedConversationId) {
      json.conversationId = cachedConversationId
    }

    fetch(process.env.VUE_APP_BASE_API + '/api/thirdparty-stream/chat_message/019a0f02-45cb-7470-a4dd-5a67b3d1403b', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json)
    })
      .then(response => {
        const reader = response.body.getReader()
        const decoder = new TextDecoder('utf-8')
        let buffer = ''
        let partialChunk = ''
        let fullAnswer = ''
        let isFirstChunk = true // 新增标志，用于判断是否是第一个有效数据块

        // 创建初始的 message 对象
        const message = {
          type: 0,
          from: 1,
          choices: '1',
          content: '',
          source: 'deepseekChat'
        }

        // 先提交一次空内容的消息，用于创建对应的 div
        store.commit('appendBubble', buildData(message))
        // 记录消息在 messages 数组中的索引
        const messageIndex = store.state.messages.length - 1
        const processData = (dataStr) => {
          const lines = (partialChunk + dataStr).split('\n')
          partialChunk = lines.pop() || '' // 保存未完成的行
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice(6)) // 提取JSON数据
                const answerChunk = data.content
                fullAnswer += answerChunk
                // 更新 message 对象的 content 属性
                message.content = fullAnswer
                // 直接更新 messages 数组中对应消息的 content 属性
                store.state.messages[messageIndex].content = fullAnswer

                // 检查是否为 deepseekChat 消息并更新 deepseekChatMessages 数组
                if (message.source === 'deepseekChat') {
                  if (store.state.deepseekChatMessages.length > 0) {
                    store.state.deepseekChatMessages[store.state.deepseekChatMessages.length - 1].content = fullAnswer
                  }
                }
                // 检查是否有新的 conversation_id 并缓存
                if (data.conversation_id) {
                  cacheConversationId(data.conversation_id)
                }

                // 若为第一个有效数据块，隐藏 loading
                if (isFirstChunk) {
                  const removedLoading = loadings.shift()
                  if (removedLoading) {
                    store.commit('deleteBubble', removedLoading)
                  }
                  isFirstChunk = false
                }
              } catch (e) {
                // console.error('解析错误:', e)
              }
            }
          }
        }

        const readStream = () => {
          reader.read().then(({ done, value }) => {
            if (done) {
              // 流结束后的清理工作
              if (partialChunk) processData('')
              // 流结束后，将完整回答添加到 messages 中
              resolve({
                data: [message],
                applyId: null,
                chatId: null,
                sid: null,
                errorCount: null
              })
              return
            }
            buffer += decoder.decode(value, { stream: true })
            processData(buffer)
            buffer = ''
            readStream()
          })
        }

        readStream()
      })
      .catch(err => {
        console.error('请求失败:', err)
        reject(err)
      })
  })
}

const messageSender = {
  async robot (message, useDeepseekChat = false) {
    const store = this
    const { appConfig } = store.state
    const { chatId, platform, orgCode, token, theme } = appConfig
    const { sid, errorCount } = store.state.params
    const navigationId = store.state.navigation ? store.state.navigation.id : ''

    if (!chatId || !platform || !orgCode || !token || !theme) {
      console.error('Missing required parameters in appConfig')
      const loading = loadings.shift()
      if (loading) {
        store.commit('deleteBubble', loading)
      }
      store.commit('appendBubble', {
        type: 0,
        from: 1,
        content: 'Missing required parameters in appConfig',
        source: 'error' // 标记为错误来源
      })
      return
    }

    if (!message.examId && store.state.exam) message.examId = store.state.examId
    if (!message.examName && store.state.exam) message.examName = store.state.examName
    if (!message.navigationName && store.state.navigationName) message.navigationName = store.state.navigationName

    const apiMethod = useDeepseekChat ? deepseekChat : askQuestion

    if (message.dataType && message.dataType === 'relBusiness-selected') {
      let json = {}
      if (apiMethod === deepseekChat) {
        json = {
          message: message.text,
          stream: true,
          re_chat: false,
          // userId: new Fingerprint().get(),
          conversationId: ''
        }
      } else {
        json = {
          chatId,
          sid,
          errorCount,
          platform,
          orgCode,
          token,
          theme,
          sceneId: store.state.sceneId,
          navigationId,
          ...message
        }
      }
      await apiMethod(json)
      return
    }

    message.type = 0
    store.commit('appendBubble', buildData(message))

    const loading = buildData({
      type: 'loading'
    })

    loadings.push(loading)
    store.commit('appendBubble', loading)

    let jsonTwo = {}
    if (apiMethod === deepseekChat) {
      jsonTwo = {
        message: message.text,
        stream: true,
        re_chat: false
        // query: message.text,
        // userId: new Fingerprint().get(),
        // conversationId: ''
      }
    } else {
      jsonTwo = {
        chatId,
        sid,
        errorCount,
        platform,
        orgCode,
        token,
        navigationId,
        sceneId: store.state.sceneId,
        ...message
      }
    }

    try {
      let responseData
      if (apiMethod === deepseekChat) {
        responseData = await handleDeepSeekStreamResponse(apiMethod, jsonTwo, store)
      } else {
        responseData = await apiMethod(jsonTwo)
        const { data, applyId } = responseData
        const validData = data.filter(item => Object.keys(item).length > 0)
        validData.forEach((item, index) => {
          item.dataType = message.dataType
          if (Object.keys(item).length) item.applyId = applyId
          if (validData[index + 1] && validData[index + 1].type === 23) {
            item.style = 25
          } else if (item.type === 0 && item.content) {
            item.type = 888
          }
          if (item.t === true) {
            validData.push({
              type: 'feedback',
              applyId
            })
          }
          if (item.a === true) {
            store.commit('updateLevel', 4)
          }
          item.source = 'askQuestion' // 标记来源
          // 检查是否为 deepseekChat 消息并更新 deepseekChatMessages 数组
          if (item.source === 'deepseekChat') {
            console.log(item, 'deepseekChat内容')
            store.commit('addDeepSeekChatMessage', item)
          }
        })
        store.commit('appendBubble', validData)
      }

      const {
        chatId: chatIdRes,
        sid: sidRes,
        errorCount: errorCountRes
      } = responseData

      store.commit('storeRemoteParams', {
        chatId: chatIdRes,
        sid: sidRes,
        errorCount: errorCountRes
      })

      const removedLoading = loadings.shift()
      if (removedLoading) {
        store.commit('deleteBubble', removedLoading)
      }
    } catch (error) {
      const removedLoading = loadings.shift()
      if (removedLoading) {
        store.commit('deleteBubble', removedLoading)
      }
      store.commit('appendBubble', {
        type: 0,
        from: 1,
        content: error.toString(),
        source: 'error' // 标记为错误来源
      })
    }
  },
  staff (message) {
    const store = this
    store.commit('appendBubble', buildData(message))
    Staff.post(message.question)
  }
}

const store = new Vuex.Store({
  state: {
    robotConfig: {},
    appConfig: window.config,
    chatId: null,
    messages: [],
    voice: [],
    navigation: null,
    exam: [],
    examId: '',
    examName: '',
    sceneId: '',
    level: 0,
    params: {},
    ui: {
      footerHeight: 'auto'
    },
    uselessCount: 0,
    related: 'deepseek回答问题',
    suggest: '您可能关注下列建议问题',
    examChoose: '请选择您要咨询的类别',
    examChooseVoice: '',
    freshNeed: false,
    chattingType: 'robot',
    staffFeedback: false,
    deepseekChatMessages: [] // 新增数组用于存储 deepseekChat 消息
  },
  getters: {
    displayVoice (state) {
      return state.voice[state.voice.length - 1]
    },
    exam (state) {
      if (state.exam.length < 1) {
        return null
      } else {
        let isLevel3 = false
        let examHit
        for (let i = state.exam.length - 1; i >= 0; i--) {
          const exam = state.exam[i]
          if (!isLevel3 && exam.level === 3) {
            isLevel3 = true
          } else if (isLevel3 && exam.level !== 3) {
            if (i === state.exam.length - 1) {
              examHit = exam
            } else {
              examHit = state.exam[i + 1]
            }
            break
          }
        }
        if (!examHit) {
          examHit = state.exam.filter(item => item.level === 1 || item.level === 2).pop()
        }
        return examHit
      }
    },
    getDeepSeekChatMessages (state) {
      return state.deepseekChatMessages
    }
  },
  mutations: {
    appendBubble ({ messages, voice, appConfig, uselessCount }, message) {
      if (typeOf(message) === 'object') {
        if (message.type === 14) {
          this.state.related = message.content
          return
        }
        if (message.type === 15) {
          this.state.suggest = message.content
          return
        }
        if (message.type === 19) {
          this.state.examChoose = message.content
          this.state.examChooseVoice = message.data
          return
        }
        message.type === 9999 ? voice.push(message) : messages.push(message)
        if (message.content && message.content.indexOf(appConfig.staticMessages.NO_ANSWER_TXT) > -1) {
          uselessCount++
        }
      } else if (typeOf(message) === 'array') {
        const msgList = []
        message.forEach(item => {
          if (item && Object.keys(item).length) {
            item.type === 9999 ? voice.push(item) : msgList.push(buildData(item))
            if (item.content && item.content.indexOf(appConfig.staticMessages.NO_ANSWER_TXT) > -1) {
              uselessCount++
            }
            if ((item.type === 0 || item.type === 888) && item.f) {
              switcher.switchToStaff.call(this)
            }
          }
        })
        messages.push(msgList)
      }
    },
    insertMessage (state, data) {
      typeOf(data) === 'array'
        ? data.forEach(message => store.commit('appendBubble', message))
        : store.commit('appendBubble', data)
    },
    updateLayout (state, layout) {
      state.ui.footerHeight = layout.footerHeight
    },
    deleteBubble: (function () {
      let start = 0
      return function (state, data) {
        const length = state.messages.length
        for (; start < length; start++) {
          const current = state.messages[start]
          if (typeOf(current) === 'object' && current.id === data.id) {
            state.messages.splice(start, 1)
            return
          }
        }
      }
    })(),
    setChatId ({ chatId }, data) {
      chatId = data
    },
    storeNavigation (store, data) {
      store.navigation = data
    },
    updateExam (state, data) {
      if (data && data.level) {
        state.level = data.level
      }
      if (data === null) {
        state.exam.splice(0)
      } else if (data === undefined) {
        state.exam.pop()
      } else {
        state.exam.push(data)
      }
    },
    storeRemoteParams (state, data) {
      Object.keys(data).forEach(key => {
        state.params[key] = data[key]
      })
    },
    updateLevel (state, data) {
      state.level = data
    },
    updateExamName (state, data) {
      state.examName = data
    },
    updateExamId (state, data) {
      state.examId = data
    },
    updateSceneId (state, data) {
      state.sceneId = data
    },
    updateFreshNeed (state, data) {
      state.freshNeed = data
    },
    switchRole (state, type) {
      if (state.chattingType === type) {
        return false
      }
      state.chattingType = type
    },
    setStaffFeedback (state, payload) {
      state.staffFeedback = payload
      console.log('当前会话' + (state.staffFeedback ? '' : '不') + '需要客户反馈满意度')
    },
    addDeepSeekChatMessage (state, message) {
      state.deepseekChatMessages.push(message)
    }
  },
  actions: {
    async getRobotConfig (store) {
      const orgCode = store.state.appConfig.orgCode
      const result = await getRobotConfig({
        orgCode
      })
      if (result.code === 0) {
        const data = result.data
        const config = data.find(item => item.type === 5)
        const user = data.find(item => item.user)
        user.user.orgCode = user.user.orgCode || orgCode
        user && cache.set('user', user.user)
        store.state.robotConfig = config || {}
      }
    },
    async initApp (store) {
      const { appConfig } = store.state
      const { chatId, platform, orgCode, token, theme } = appConfig
      if (!chatId || !platform || !orgCode || !token || !theme) {
        console.error('Missing required parameters in appConfig')
        return
      }
      try {
        const { data } = await initApp({
          chatId,
          platform,
          orgCode,
          token,
          theme
        })
        data.forEach(item => store.commit('appendBubble', buildData(item)))
      } catch (e) {
        console.log(e)
      }
    },
    async askQuestion (store, message) {
      console.warn('store处理消息交互，当前的客服类型是', store.state.chattingType)
      console.log('dataType:' + message.dataType)
      if (store.state.chattingType === 'staff' && message.onlyRobot) {
        const isSwitcher = await confirm({
          content: staffExit
        })
        if (isSwitcher) {
          store.commit('switchRole', 'robot')
          Staff.close()
        } else {
          return false
        }
      }
      messageSender[store.state.chattingType].call(store, message, false)
    },
    async deepseekChat (store, message) {
      console.warn('store处理消息交互，deepseekChat', store, message.text)
      if (store.state.chattingType === 'staff' && message.onlyRobot) {
        const isSwitcher = await confirm({
          content: staffExit
        })
        if (isSwitcher) {
          store.commit('switchRole', 'robot')
          Staff.close()
        } else {
          return false
        }
      }
      messageSender[store.state.chattingType].call(store, message, true)
    },
    async StaffFeedbackScore (store, data) {
      let satiscomment = ''
      if (data > 3) {
        satiscomment = await confirm({
          content: StaffYawp,
          theme: 'pop-reason'
        })
      }
      Staff.feedback({
        satislevel: data,
        satiscomment
      })
      store.commit('insertMessage', {
        from: 0,
        type: -1,
        content: '感谢您的反馈',
        dataType: 'sysmsg'
      })
    }
  }
})

export default store
